const UserGroup = {
  LocqAdmin: "locq_admin",
};

export default UserGroup;
